import React, { useEffect } from 'react';
import { useApiClient } from '@marageti/z4-lib';
import { RoleName } from '@marageti/z4-sdk/lib/auth/User';
import RemindersView from './reminders-view';
import useReminders from '../../hooks/use-reminders';
import { useAuthStore } from '../../store';
import useURLSearchQuery from '../../hooks/use-url-for-search-query';

interface DefaultSearch extends Record<string, string | string[]> {
  assignee: string;
}

const RemindersContainer = () => {
  const apiClient = useApiClient();
  const { loggedInAgent } = useAuthStore();
  const isAdmin = loggedInAgent?.userInfo[0].roles?.includes(RoleName.AGENT_ADMIN) || false;
  const [queryValues, updateURLQuery] = useURLSearchQuery<DefaultSearch>({
    assignee: loggedInAgent?.id || 'all',
  });

  const {
    overDueReminders,
    dueTodayReminders,
    dismissReminder,
    snoozeReminder,
  } = useReminders({
    assignee: queryValues.assignee === 'all' ? undefined : queryValues.assignee,
  });

  const handleAssigneeChange = (assignee: string) => {
    updateURLQuery({ assignee });
  };

  const FilterOverdueReminders = overDueReminders.data?.hits?.filter((tripMatch) => tripMatch.reminder.index !== 0 && tripMatch.reminder.index !== -1);

  useEffect(() => {
    const trackPageVisit = async () => {
      try {
        await apiClient.zeventsClient.postPageVisitedEvent(window.location.href);
      } catch (error) {
        console.warn('Failed to track page visit:', error);
      }
    };

    trackPageVisit();
  }, [apiClient]);

  return (
    <RemindersView
      overdueReminders={FilterOverdueReminders || []}
      dueTodayReminders={dueTodayReminders.data?.hits || []}
      isLoading={overDueReminders.isLoading || dueTodayReminders.isLoading}
      error={overDueReminders.error || dueTodayReminders.error}
      dismissReminder={dismissReminder}
      snoozeReminder={snoozeReminder}
      isAdminViewer={isAdmin}
      selectedAssignee={queryValues.assignee as string}
      handleAssigneeChange={handleAssigneeChange}
    />
  );
};

export default RemindersContainer;
